var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoriesEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 299,
    height: 221,
    viewBox: "0 0 299 221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "169.961%",
    x2: "38.532%",
    y1: "-324.054%",
    y2: "125.543%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#44C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B9F9F0",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-40h300v300H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M264.255 111.742C263.59 172.197 214.41 221 153.842 221 92.86 221 43.423 171.527 43.423 110.5c0-5.053.34-10.026.995-14.899H9.933C4.447 95.601 0 91.154 0 85.67c0-5.486 4.447-9.933 9.933-9.933h78.146c5.486 0 9.933-4.447 9.933-9.933a9.936 9.936 0 0 0-6.468-9.311 9.912 9.912 0 0 1-3.464.62H42.19c-5.486 0-9.933-4.447-9.933-9.932 0-5.486 4.447-9.933 9.933-9.933H71.17C91.401 14.401 120.941 0 153.842 0 201.3 0 241.763 29.96 257.38 72.011h31.688c5.486 0 9.933 4.447 9.933 9.933 0 5.485-4.447 9.932-9.933 9.932h-48.371c-5.486 0-9.933 4.447-9.933 9.933s4.447 9.933 9.933 9.933h23.559z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(110 66)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#80959D",
    d: "M4 0h57.437l30.754 35.335v85.692a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.357,
    cy: 36.319,
    fill: "#EB8181",
    rx: 4.461,
    ry: 4.46
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.357,
    cy: 59.115,
    fill: "#EB8181",
    rx: 4.461,
    ry: 4.46
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.357,
    cy: 81.912,
    fill: "#EB8181",
    rx: 4.461,
    ry: 4.46
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.357,
    cy: 104.708,
    fill: "#EB8181",
    rx: 4.461,
    ry: 4.46
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    strokeLinecap: "square",
    strokeWidth: 2,
    d: "M26.867 33.478h26.08M26.867 55.478h26.08M26.867 78.478h26.08M26.867 101.478h26.08"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    strokeLinecap: "square",
    d: "M26.867 40.478h12.144M26.867 62.478h12.144M26.867 85.478h12.144M26.867 108.478h12.144"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 106,
    r: 20,
    fill: "#87D5FA"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77 93)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.813 5.568C8.389 2.575 10.928.32 13.973.32s5.585 2.256 6.16 5.25h4.684L21.51 15.745H7.588L4.375 5.568h3.438zm5.224 4.845h2.192V8.132h2.192V5.851h-2.192V3.57h-2.192v2.28h-2.191v2.282h2.191v2.281z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M0 2.624h3.012l5.235 15.747h12.751"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.062,
    cy: 23.182,
    fill: "#FFF",
    rx: 2.187,
    ry: 2.187
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.686,
    cy: 23.182,
    fill: "#FFF",
    rx: 2.187,
    ry: 2.187
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#80959D",
    d: "M61.054.408v32.4a4 4 0 0 0 4 4h26.775"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriesEmpty);
export default __webpack_public_path__ + "static/media/categories-empty.833e62b959ee1702158c9ee37828f551.svg";
export { ForwardRef as ReactComponent };